export default __webpack_public_path__ + "static/1-2cb6c869690802b12ead645a6fada99f.jpeg";